import { useMemo } from 'react';
import { defaultCountries } from 'react-international-phone';
import Location from '@r6digital/rapidstor-types/react/entities/Location';
import { RapidStorSettings } from '../utils/rapidstor';

export default function useDefaultCountry(location: Location) {
    const { dialCodeSelector } = window.rapidstor_settings.rapidstor_options;

    return useMemo(() => {
        if (!dialCodeSelector) {
            return undefined;
        }

        const country = RapidStorSettings(location).country();
        if (!country) {
            return 'gb';
        }

        const countryIso2 = country.toLowerCase();
        const foundCountry = defaultCountries.find((c) => c[1] === countryIso2);
        return foundCountry ? countryIso2 : 'gb';
    }, [location, dialCodeSelector]);
}
